// extracted by mini-css-extract-plugin
module.exports = {"icon":"ShopRedirectButton_icon__39rsy"};